/*
 *
 * UserAction actions
 *
 */

import { action } from 'typesafe-actions';

import ActionTypes, { SaveMode } from './constants';

export const saveFurnitureRequestAction = (saveMode?: SaveMode) =>
  action(ActionTypes.SAVE_FURNITURE_REQUEST, { saveMode });
export const saveFurnitureSuccessAction = (saveMode?: SaveMode) =>
  action(ActionTypes.SAVE_FURNITURE_SUCCESS, { saveMode });
export const saveFurnitureFailureAction = (
  error: string,
  saveMode?: SaveMode,
) => action(ActionTypes.SAVE_FURNITURE_FAILURE, { error, saveMode });
export const resetSaveModeAction = () => action(ActionTypes.RESET_SAVEMODE);
